import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const MasterAreaPickingRBAC = {
  pageID: '0b8256d2e551493d1fd3ca2eb03c31d1',
  elementID: {
    ViewList: '0aea3ae080b53bd1359ca12b3fa69726',
    BtnUpsert: '6428f98ac0009a04e2ec87a7a915797a',
  },
} as const
export const useRBACMasterAreaPickingPage = createUseRBAC(MasterAreaPickingRBAC.elementID)
export type UseRBACMasterAreaPickingPageType = ReturnType<typeof useRBACMasterAreaPickingPage>

export const MasterAreaPickingUpsertRBAC = {
  pageID: '388338c20bc3da1122c7685fbcba7af0',
  elementID: {
    ViewMasterAreaPickingUpsert: '3d10c244f0ac6ccc5701602ec9a7f3fe',
  },
} as const
export const useRBACMasterAreaPickingUpsertPage = createUseRBAC(
  MasterAreaPickingUpsertRBAC.elementID,
)
export type UseRBACMasterAreaPickingUpsertPageType = ReturnType<
  typeof useRBACMasterAreaPickingUpsertPage
>
